import Rollbar from 'rollbar';
import packageInfo from '../package.json';

export default () => {
  const rollbarConfig = {
    accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: import.meta.env.VITE_MODE || 'unknown',
    autoInstrument: true,
    code_version: packageInfo.version,
  };
  const rollbar = new Rollbar(rollbarConfig);
  return { rollbar };
};
